module.exports = __webpack_public_path__ + "static/media/Othernawmanlogo.d7b45631.png";